<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-30 no-padding">
        <cmp-preview-list-comp @returnCmpPreview="onClickCmpPreviewList" ref="cmpPreviewListSearch"></cmp-preview-list-comp>
      </div>
      <div class="md-layout-item md-size-40 no-padding">
        <md-card>
          <md-card-header>
            <h4 class="title">
              <md-icon>person</md-icon>대상 교우
            </h4>
          </md-card-header>
          <cmp-result-list-comp :total-target-member-cnt.sync="totalTargetMemberCnt" @returnCmpResult="onClickCmpResultList" @returnCmpResultListCnt="setCmpResultListCnt" ref="cmpResultListSearch"></cmp-result-list-comp>
        </md-card>
      </div>
      <div class="md-layout-item md-size-30 no-padding">
        <user-list-comp ref="userListSearch" :total-target-member-cnt.sync="totalTargetMemberCnt" @returnDistCmpResultSuccess="reloadCmpResultList"></user-list-comp>
      </div>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import parser from "@/kuaa/kuaa-parser";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import axios from "axios";

import cmpPreviewListComp from "@/pages/Counselor/Components/cmpPreviewListComp"
import cmpResultListComp from "@/pages/Counselor/Components/cmpResultListComp"
import userListComp from "@/pages/Counselor/Components/userListComp"

export default {
  components: {
    cmpPreviewListComp,
    cmpResultListComp,
    userListComp
  },

  data() {
    return {
      totalTargetMemberCnt : 0,
    }
  },

  methods: {
    onClickCmpPreviewList(item) {
      this.$refs.cmpResultListSearch.sendQuery(item.CCmpId);
      this.$refs.userListSearch.getUserList();
      this.$refs.userListSearch.setCmp(item);
      this.$refs.userListSearch.searchCmpLTypes();
    },
    onClickCmpResultList(item) {
      
    },
    setCmpResultListCnt(cnt) {
      this.$refs.userListSearch.cmpResultListCnt = cnt;
    },
    reloadCmpResultList(item) {
      this.$refs.cmpResultListSearch.sendQuery(item.CCmpId);
    }
  }
}
</script>

<style>

</style>